import { extend } from 'quasar'
// const uuidv4 = require('uuid/v4')

export const dateSort = (a, b) => {
  let _a = Date.parse(a)
  let _b = Date.parse(b)
  return _a - _b
}
// export const guid = uuidv4()
export const numberSort = (a, b) => parseInt(a, 10) - parseInt(b, 10)
export const stringSort = (a, b) => a.toString().localeCompare(b.toString())
export const relationSortId = (a, b) => numberSort(a.id, b.id)
export const relationSortLength = (a, b) => numberSort(a.length, b.length)
export const booleanComponent = {
  // is: 'q-select',
  // is: 'q-checkbox',
  is: 'q-toggle',
  filterIs: 'select-filter',
  props: {
    trueValue: true,
    falseValue: false,
    // color: 'primary',
    options: [
      {
        label: 'Yes',
        value: true
      },
      {
        label: 'No',
        value: false
      }
    ]
  }
}
export const inputTextField = ({ type = 'text', req = false, validation = null, money = false, max = null, min = null }) => {
  if (!validation) {
    validation = {}
    if (req) {
      validation.required = true
    }
    if (type === 'string') {
      validation.min = 1
    }
    if (type === 'number' && !money) {
      validation.numeric = true
      if (max && min) {
        validation.between = [min, max]
      }
    }
    if (type === 'email') {
      validation.email = true
    }
  }
  return {
    is: 'q-input',
    props: {
      type: type,
      maxlength: max || 500,
      decimals: money ? 2 : null,
      readonly: false,
      disable: false
    },
    validation: validation
  }
}
/**
 * @param props
 * @param type
 * @param label
 * @param namespace
 * @param localKey
 * @param fk
 * @param componentIs
 * @param filterIs
 * @param validation
 * @param parentRestraint
 * @param saveBeforeAndAfter
 * @returns {{sort: boolean, sortable: boolean, component: {is: (*|string), filterIs: string, props, validation}, relation: {type: string, label: string, namespace: string, localKey: *, fk: *, nested: *, subtitle: *, parentRestraint: boolean, saveBeforeAndAfter: boolean}}}
 */
export const relationField = ({
  props = {},
  label = 'label',
  type = 'one',
  namespace = 'self',
  localKey,
  fk,
  componentIs = null,
  filterIs = 'text-filter',
  validation = {},
  parentRestraint = false,
  requiresParentSave = false,
  saveBeforeAndAfter = false,
  linkTable = false,
  linkTableModel = null,
  fieldType = 'text',
  directSearch = false,
  searchColumns = false,
  orderBy = false,
  filterable = true,
  searchable = true,
  sortable = true
}) => {
  const component = type === 'one' ? 'relation-field-one' : 'relation-field-many'
  return {
    filterable: filterable,
    searchable: searchable,
    sort: sortable && type === 'one',
    sortable: sortable && type === 'one',
    component: {
      is: componentIs || component,
      filterIs,
      props,
      validation
    },
    relation: {
      label: label || 'label',
      type: type || 'one',
      namespace: namespace || 'self',
      localKey: localKey,
      fk: fk,
      fieldType: fieldType,
      directSearch,
      parentRestraint,
      requiresParentSave,
      saveBeforeAndAfter,
      linkTable,
      linkTableModel,
      searchColumns,
      orderBy
    }
  }
}

export const fileField = ({ req = false, multiple = false, field, label = 'File', mediaCollection, extensions = '.pdf,.xls,.xlsx,.doc,.docx', visible = true, description = '' }) =>
  extend(
    true,
    {},
    {
      label: label,
      field: field,
      name: field,
      section: 'Files',
      sort: false,
      sortable: false,
      filterable: false,
      visible: visible,
      searchable: false,
      align: 'left',
      type: 'file',
      description,
      component: {
        is: 'file-upload-field',
        media: mediaCollection,
        validation: {
          required: req
        },
        props: {
          extensions,
          sendRaw: false,
          name: 'file',
          method: 'POST',
          multiple,
          headers: {},
          additionalFields: [
            {
              name: 'media',
              value: mediaCollection
            }
          ]
        }
      }
    }
  )

export const inputRequired = {
  is: 'q-input',
  props: {},
  validation: {
    required: true
  }
}
export const editorComponent = {
  is: 'q-editor',
  filterIs: 'text-filter',
  props: {
    toolbarFlat: true,
    toolbarOutline: false,
    color: 'grey-9',
    toolbar: [
      ['bold', 'italic', 'strike', 'underline'],
      ['token', 'hr', 'link'],
      [
        {
          label: 'Headline',
          icon: 'title',
          list: 'no-icons',
          options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
        },
        {
          label: 'Font Size',
          icon: 'format_size',
          fixedLabel: true,
          fixedIcon: true,
          list: 'no-icons',
          options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
        },
        'removeFormat'
      ]
    ]
  }
}
export const defaultColumn = {
  name: '',
  field: 'label',
  label: '',
  visible: true,
  searchable: true,
  filterable: true,
  roles: [],
  type: 'string',
  searchType: null,
  icon: null,
  sortable: true,
  displayValue: undefined,
  noSave: false,
  component: {
    is: 'q-input',
    props: {},
    validation: {}
  },
  align: 'left'
}
export const createColumn = options =>
  extend(
    true,
    {},
    defaultColumn,
    {
      name: options.field,
      label: options.label || options.field || 'no label',
      section: 'General',
      description: '',
      filterable: options.hasOwnProperty('filterable') ? options.filterable : options.hasOwnProperty('searchable') ? options.searchable : defaultColumn.filterable,
      sort: options.type === 'number' ? numberSort : null
    },
    options
  )
export const defaultColumns = [
  createColumn({
    label: 'ID',
    field: 'id',
    visible: false,
    searchable: true,
    type: 'number',
    sortable: true,
    filterable: true,
    component: null
  }),
  createColumn({
    label: 'Date Deleted',
    field: 'removalDate',
    type: 'date',
    section: 'Data Info',
    visible: false,
    searchable: true,
    filterable: true,
    sortable: true,
    defaultValue: null,
    component: null
    /*
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        disable: true
      }
    }
    */
  })
  //   createColumn({
  //     label: 'Updated',
  //     field: 'updatedAt',
  //     visible: false,
  //     searchable: false,
  //     type: 'string',
  //     sortable: true,
  //     component: null
  //   }),
  //   createColumn({
  //     label: 'Created',
  //     field: 'createdAt',
  //     visible: false,
  //     searchable: false,
  //     type: 'string',
  //     sortable: true,
  //     component: null
  //   })
  /*
  createColumn({
    label: 'Edit',
    field: 'action_edit',
    visible: true,
    searchable: false,
    filterable: false,
    align: 'left',
    type: 'action-edit',
    sortable: false,
    component: null
  })
  */
]

const states = require('../../json/states.json')

export const stateOptions = Object.keys(states).map(key => {
  return {
    label: states[key],
    value: key
  }
})

export const addressFields = ({ req = false }) => [
  createColumn({
    label: 'Address',
    field: 'address',
    section: 'Address',
    visible: false,
    sortable: true,
    component: inputTextField({ req: req })
  }),
  createColumn({
    label: 'City',
    field: 'city',
    section: 'Address',
    visible: false,
    sortable: true,
    component: inputTextField({ req: req })
  }),
  createColumn({
    label: 'State',
    field: 'state',
    section: 'Address',
    visible: true,
    sortable: true,
    component: {
      is: 'q-select',
      filterIs: 'select-filter',
      validation: { required: req },
      props: {
        options: stateOptions,
        filter: true,
        autofocusFilter: true
      }
    }
  }),
  createColumn({
    label: 'Zip',
    field: 'zip',
    section: 'Address',
    visible: false,
    sortable: true,
    component: inputTextField({ req: req })
  })
]

export const editActionColumn = createColumn({
  label: 'Edit',
  field: 'action_edit',
  visible: true,
  searchable: false,
  filterable: false,
  align: 'left',
  type: 'action',
  sortable: false,
  component: null
})

export const deleteActionColumn = createColumn({
  label: 'Delete',
  field: 'action_delete',
  visible: true,
  searchable: false,
  filterable: false,
  align: 'right',
  type: 'action',
  sortable: false,
  component: null
})
